export default __webpack_public_path__ + "static/media/kansas.8f758eb3.png";